export const LOGO_URL = "/assets/billions_logo.webp";

export const IMAGES = {
  heroHome:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=85&w=1920&auto=format&fit=crop",
  chiSiamoHero:
    "https://images.unsplash.com/photo-1771270759486-1f7703945072?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBkYXJrfGVufDB8fHx8MTc5MTkxNzgxNnww&ixlib=rb-4.1.0&q=85",
};

export const DIVISIONI = [
  {
    id: "food",
    numero: "01",
    nome: "Food",
    sottotitolo: "Food & Italian Excellence",
    payoff: "Tradizione italiana. Visione internazionale.",
    tagline: "Eccellenza gastronomica italiana",
    descrizione:
      "Billions Group opera nel settore food con l'obiettivo di valorizzare le eccellenze gastronomiche italiane e accompagnarle verso nuove opportunità di crescita, in Italia e all'estero. Attraverso strategie di branding, marketing, posizionamento commerciale e sviluppo distributivo, il Gruppo costruisce progetti capaci di coniugare qualità del prodotto, identità e potenziale di mercato. Dalla ristorazione alla distribuzione organizzata, fino ai mercati internazionali, lavoriamo per creare connessioni tra produttori, brand, distributori e partner commerciali, sviluppando modelli di business scalabili e nuove occasioni di espansione.",
    descrizioneCard:
      "Valorizziamo le eccellenze gastronomiche italiane accompagnandole verso nuove opportunità di crescita, in Italia e all'estero.",
    visione:
      "Trasformare il patrimonio gastronomico italiano in un'esperienza contemporanea, riconoscibile e competitiva sui mercati globali.",
    payoffFinale: "Italian Taste. Global Vision.",
    img: "https://images.unsplash.com/photo-1692197275441-40c874f40385?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHw0fHxnb3VybWV0JTIwZm9vZCUyMGRhcmt8ZW58MHx8fHwxNzkxOTE3ODE3fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "luxury",
    numero: "02",
    nome: "Luxury",
    sottotitolo: "Luxury & Lifestyle",
    payoff: "Esclusività. Identità. Valore.",
    tagline: "Il lusso come linguaggio",
    descrizione:
      "Nel mondo del lusso, ogni dettaglio contribuisce a definire un'identità. Billions Group sviluppa e valorizza progetti legati al luxury lifestyle, interpretando l'esclusività come un equilibrio tra qualità, reputazione, esperienza e posizionamento. Il nostro approccio integra visione strategica, sviluppo del brand, comunicazione e costruzione di relazioni qualificate, con l'obiettivo di creare proposte distintive e coerenti con le aspettative di un pubblico esigente. Dai prodotti e servizi premium alle esperienze esclusive, individuiamo opportunità in cui identità, desiderabilità e valore percepito possono diventare elementi concreti di crescita.",
    descrizioneCard:
      "Sviluppiamo e valorizziamo progetti legati al luxury lifestyle, dove ogni dettaglio definisce un'identità.",
    visione:
      "Creare progetti che si distinguano per personalità, cura e capacità di generare valore nel tempo.",
    payoffFinale: "Beyond Luxury. Into Value.",
    img: "https://images.unsplash.com/photo-1543263207-e9f51e055c62",
  },
  {
    id: "hospitality",
    numero: "03",
    nome: "Hospitality",
    sottotitolo: "Hospitality & Experiences",
    payoff: "Ospitalità. Emozioni. Opportunità.",
    tagline: "Ospitalità senza compromessi",
    descrizione:
      "Billions Group interpreta l'ospitalità come un settore in cui identità, territorio, qualità del servizio e capacità gestionale concorrono alla creazione di valore. Il Gruppo promuove lo sviluppo e il riposizionamento di strutture ricettive, progetti di boutique hospitality e format esperienziali, attraverso una visione che integra strategia commerciale, organizzazione, marketing e sviluppo dei canali di vendita. Valorizziamo il carattere distintivo di ogni struttura, costruendo proposte capaci di dialogare con il turismo nazionale e internazionale e di rispondere alle nuove esigenze del viaggiatore. Dall'identità della destinazione alla strategia di distribuzione, ogni elemento è concepito per rafforzare l'attrattività del progetto e migliorarne il potenziale di sviluppo.",
    descrizioneCard:
      "Sviluppo e riposizionamento di strutture ricettive, boutique hospitality e format esperienziali.",
    visione:
      "Trasformare luoghi e strutture in destinazioni riconoscibili, capaci di offrire esperienze autentiche e generare valore duraturo.",
    payoffFinale: "Exceptional Places. Memorable Experiences.",
    img: "https://images.pexels.com/photos/13722826/pexels-photo-13722826.jpeg",
  },
  {
    id: "real-estate",
    numero: "04",
    nome: "Real Estate",
    sottotitolo: "Real Estate & Development",
    payoff: "Strategia immobiliare. Valore concreto.",
    tagline: "Spazi che generano valore",
    descrizione:
      "Billions Group sviluppa iniziative nel settore immobiliare attraverso un approccio orientato alla valorizzazione degli asset, allo sviluppo commerciale e alla costruzione di opportunità di business. L'attività comprende la ricerca e l'analisi di opportunità, il posizionamento commerciale degli immobili, lo sviluppo di partnership e il coordinamento di progetti finalizzati a esprimere al meglio il potenziale di ciascun asset. Attraverso una rete di relazioni professionali e un approccio integrato, il Gruppo favorisce l'incontro tra proprietà, operatori, investitori e partner, promuovendo iniziative coerenti con gli obiettivi e le caratteristiche di ogni progetto. Dalla valorizzazione di singole proprietà allo sviluppo di operazioni strutturate, ogni iniziativa nasce da una lettura strategica del mercato e da una visione orientata al risultato.",
    descrizioneCard:
      "Valorizzazione degli asset, sviluppo commerciale e costruzione di opportunità di business immobiliare.",
    visione:
      "Trasformare opportunità immobiliari in progetti di valore, coniugando analisi, strategia e sviluppo.",
    payoffFinale: "Real Assets. Strategic Value.",
    img: "https://images.pexels.com/photos/13722886/pexels-photo-13722886.jpeg",
  },
  {
    id: "beauty",
    numero: "05",
    nome: "Beauty",
    sottotitolo: "Beauty & Personal Care",
    payoff: "Identità. Innovazione. Desiderabilità.",
    tagline: "Bellezza, ricerca, identità",
    descrizione:
      "Billions Group guarda al settore beauty come a un mercato in continua evoluzione, in cui ricerca, identità di marca, qualità percepita e capacità di comunicazione rappresentano leve decisive per distinguersi. Il Gruppo affianca lo sviluppo di progetti nel mondo della bellezza e della cura della persona, contribuendo alla definizione del posizionamento, alla strategia di branding, alla comunicazione e all'espansione commerciale. L'obiettivo è costruire identità riconoscibili, individuare segmenti di mercato promettenti e creare le condizioni per una crescita coerente con il potenziale del prodotto e le aspettative dei consumatori. Dalla definizione del concept alla costruzione dei canali distributivi, lavoriamo per dare forma a proposte distintive, capaci di coniugare estetica, innovazione e opportunità di mercato.",
    descrizioneCard:
      "Posizionamento, branding ed espansione commerciale per progetti di bellezza e cura della persona.",
    visione:
      "Trasformare idee e prodotti in brand desiderabili, con una personalità forte e una prospettiva di sviluppo internazionale.",
    payoffFinale: "Beauty with a Vision.",
    img: "https://images.pexels.com/photos/7946640/pexels-photo-7946640.jpeg",
  },
  {
    id: "new-venture",
    numero: "06",
    nome: "New Venture",
    sottotitolo: "New Venture & Business Development",
    payoff: "Dalle idee alle nuove imprese.",
    tagline: "Il futuro, oggi",
    descrizione:
      "New Venture è l'area di Billions Group dedicata all'identificazione, allo sviluppo e alla strutturazione di nuove iniziative imprenditoriali. Partiamo dalle opportunità di mercato per costruire progetti con una visione chiara, un modello di business coerente e concrete prospettive di crescita. Affianchiamo imprenditori, partner e realtà aziendali nella definizione della strategia, nello sviluppo del concept, nel posizionamento e nella costruzione di partnership. Il nostro approccio combina visione imprenditoriale, analisi delle opportunità, sviluppo commerciale e capacità di mettere in relazione competenze e risorse complementari. Dalla nascita di nuovi brand alla creazione di società e allo sviluppo di partnership strategiche, lavoriamo per trasformare potenzialità in iniziative strutturate, capaci di evolvere e raggiungere nuovi mercati.",
    descrizioneCard:
      "Identificazione, sviluppo e strutturazione di nuove iniziative imprenditoriali ad alto potenziale.",
    visione:
      "Creare nuove opportunità di business e accompagnarle lungo un percorso di crescita, consolidamento ed espansione.",
    payoffFinale: "Ideas into Business. Vision into Value.",
    img: "https://images.unsplash.com/photo-1772541800741-0ff177b2c282?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwzfHxjb3Jwb3JhdGUlMjBvZmZpY2UlMjBkYXJrfGVufDB8fHx8MTc5MTkxNzgxNnww&ixlib=rb-4.1.0&q=85",
  },
];

export const PROFILO_GRUPPO = {
  eyebrow: "Profilo del Gruppo",
  titolo: "Vision. Strategy. Value.",
  testo:
    "Billions Group è una realtà imprenditoriale orientata allo sviluppo di brand, business e opportunità, con una visione trasversale e internazionale. Attraverso competenze strategiche, relazioni qualificate e una visione integrata del mercato, il Gruppo trasforma idee e potenzialità in progetti concreti, costruendo percorsi di crescita sostenibile e valore nel tempo.",
  testo2:
    "Le attività si articolano in sei aree — Food, Luxury, Hospitality, Real Estate, Beauty e New Venture — che condividono un approccio fondato su strategia, sviluppo, partnership e creazione di valore. Un gruppo, molteplici settori, un'unica visione imprenditoriale.",
  claim: "We Build Brands. We Develop Opportunities. We Create Value.",
  posizionamento:
    "Billions Group si presenta come una piattaforma imprenditoriale multidisciplinare che sviluppa brand, coordina competenze e costruisce nuove opportunità di business. Questo posizionamento conferisce coerenza alle diverse aree di attività e lascia spazio all'ingresso futuro in nuovi mercati.",
};

export const TIMELINE = [
  {
    anno: "Le origini",
    titolo: "La fondazione",
    testo:
      "Billions Group nasce in Italia da una visione imprenditoriale: unire sotto un'unica holding realtà d'eccellenza in settori diversi.",
  },
  {
    anno: "La crescita",
    titolo: "Sei business unit, un'unica visione",
    testo:
      "Il gruppo si struttura in sei business unit — Food, Luxury, Hospitality, Real Estate, Beauty e New Venture — con una direzione generale condivisa.",
  },
  {
    anno: "Oggi",
    titolo: "Eccellenza italiana, visione globale",
    testo:
      "Una rete di partner, aziende e investitori che guarda ai mercati internazionali mantenendo salde le radici italiane.",
  },
  {
    anno: "Domani",
    titolo: "La piattaforma B2B",
    testo:
      "Un ecosistema digitale dedicato a partner e aziende del gruppo: directory, partnership, progetti e opportunità condivise.",
  },
];

export const ORGANIGRAMMA = [
  {
    ruolo: "Presidenza",
    descrizione: "Indirizzo strategico e rappresentanza istituzionale del gruppo.",
  },
  {
    ruolo: "Direzione Generale",
    descrizione: "Coordinamento operativo delle divisioni e delle sedi italiane.",
  },
  {
    ruolo: "Direzioni di Divisione",
    descrizione: "Food, Luxury, Hospitality, Real Estate, Beauty, New Ventures.",
  },
  {
    ruolo: "Partnership & Sviluppo",
    descrizione: "Relazioni B2B, nuove opportunità e rete partner internazionale.",
  },
];
